import ReactComponent from './voucher_euro.svg?react'
import overridable from '../../utils/overridable'

export const Icon = ReactComponent
export default overridable('VoucherEuroIcon')(ReactComponent)
